import {
  hideBanner,
  initializeBanner,
} from "../../redux/slices/appBannerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import React from "react";
import logo from "../../assets/icons/Logo_white.png";
import { useTranslation } from "react-i18next";

const MobileAppBanner = () => {
  const dispatch = useDispatch();
  const visible = useSelector((state) => state.appBanner.visible);
  const [platform, setPlatform] = useState("other");
  const { t , i18n} = useTranslation();
  const isEng = i18n.language === "en"
  useEffect(() => {
    dispatch(initializeBanner());
    setPlatform(getMobilePlatform());
  }, [dispatch]);

  const getMobilePlatform = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(ua)) return "android";
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
    return "other";
  };

  if (!visible || platform === "other") return null;

  const links = {
    android: "https://play.google.com/store/apps/details?id=com.spring.rose",
    ios: "https://apps.apple.com/sa/app/%D8%B2%D9%87%D8%B1%D8%A9-%D8%A7%D9%84%D8%B1%D8%A8%D9%8A%D8%B9-springrose/id6705133425",
  };

  const storeLinks = {
    android: "https://play.google.com/store/apps/details?id=com.spring.rose",
    ios: "https://apps.apple.com/sa/app/%D8%B2%D9%87%D8%B1%D8%A9-%D8%A7%D9%84%D8%B1%D8%A8%D9%8A%D8%B9-springrose/id6705133425",
  };

  const handleOpenApp = (e) => {
    e.preventDefault();
    const link = links[platform];
    const fallback = storeLinks[platform];

    window.location.href = link;
    setTimeout(() => {
      window.location.href = fallback;
    }, 1000);
  };

  return (
    <div
      className="bg-purble-2 text-white py-3 flex 
        justify-start items-center text-xs w-full lg:hidden gap-2"
    >
      <button
        onClick={() => dispatch(hideBanner())}
        className={`${isEng ? "ml-4" : "mr-4"} text-white font-bold flex-shrink-0 `}
      >
        ✕
      </button>
      <img
        src={logo}
        alt="spring rose-سبرينج روز"
        className="h-14 object-cover flex-shrink-0"
      />
      <div className="w-[74%] flex justify-between items-center">
        <div className="flex flex-col justify-start items-start gap-1 w-[65%]">
          <p className="font-bold">{t("appBannerLabel")}</p>
          <p>{t("appBannerText")}</p>
        </div>
        <a
          href={links[platform]}
          onClick={handleOpenApp}
          className="h-[58px] w-[100px] bg-white text-purble-2 flex items-center
          justify-center rounded-full"
        >
          {t("openApp")}
        </a>
      </div>
    </div>
  );
};

export default MobileAppBanner;
